<template>
    <div class="height-base-mask">
        <div class="height-base-title">
            <i v-if="isShowBack" class="height-base-back" @click="close"></i>
            {{ title }}
        </div>
        <div class="height-base-content">
            <slot></slot>
        </div>
        <a class="height-close-btn" @click="close" v-if="!isShowBack"></a>
    </div>
</template>

<script>
export default {
    name: "FullHeightBaseBox",
    props: ["title", "isShowBack"],
    data() {
        return {};
    },
    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
.height-base-mask {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .height-base-title {
        position: relative;
        font-size: 16px;
        padding: 20px 16px;
        background: #fff;
        flex-grow: 0;
        &:after{
            display: inline-block;
            content: '';
            position: absolute;
            z-index: 99;
            bottom: 0;
            left: 0;
            height: 3px;
            width: 100%;
            box-shadow: 3px 3px 5px rgba(158, 159, 160, 0.15);
        }
    }

    .height-base-back {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 8px;
        vertical-align: text-bottom;
        cursor: pointer;
        background: url($zhijiStaticImagePath+"ico-back.png");
        background-size: cover;

        &:hover {
            background: url($zhijiStaticImagePath+"hover-ico-back.png");
            background-size: cover;
        }
    }

    .height-base-content {
        flex: 1;
        overflow: auto;
    }

    .height-close-btn {
        top: 13px;
        right: 11px;
        position: absolute;
        width: 44px;
        height: 38px;
        cursor: pointer;
        background: url($zhijiStaticImagePath+"i-close.png") center center no-repeat;
    }
}
</style>
